module.exports={"(optional)":"(opcional)","(required)":"(obrigatório)"};